import cx from "classnames";

import { LayoutUtilProps } from "../../types";
import { LinkProps } from "./Link";
import { useLayoutPropsUtil } from "../../internal/hooks";

import styles from "./internal/Link.module.scss";

/**
 * Props for the useLinkStyles hook.
 * @extends LayoutUtilProps
 */
export type UseLinkStylesProps = LayoutUtilProps &
  Pick<LinkProps, "className" | "appearance" | "ghost" | "style">;

/**
 * Hook for generating link styles and class names.
 *
 * @param props - The link style properties
 * @returns Object containing linkClassNames and styleCombined
 */
export const useLinkStyles = (props: UseLinkStylesProps) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  const { className, appearance = "primary", ghost, style } = componentProps;

  const linkClassNames = cx([styles["link"]], className, {
    [styles["ghost"]]: ghost,
    [styles["secondary"]]: appearance === "secondary",
  });

  const styleCombined = Object.assign({}, style, layoutStyles);

  return { linkClassNames, styleCombined };
};
